import { render, staticRenderFns } from "./SwitchToggle.vue?vue&type=template&id=516bc357&scoped=true"
import script from "./SwitchToggle.vue?vue&type=script&lang=ts"
export * from "./SwitchToggle.vue?vue&type=script&lang=ts"
import style0 from "./SwitchToggle.vue?vue&type=style&index=0&id=516bc357&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516bc357",
  null
  
)

export default component.exports